export default "__VITE_ASSET__CqW6GbTq__"